import { Injectable } from '@angular/core';

import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PublicGuardService {
  constructor(private authService: AuthService) {}

  async canActivate() {
    const hasAdfsSession = await this.authService.hasSession();

    return !hasAdfsSession;
  }
}
